import { render, staticRenderFns } from "./PastResult.vue?vue&type=template&id=77a131b8&scoped=true&"
import script from "./PastResult.vue?vue&type=script&lang=js&"
export * from "./PastResult.vue?vue&type=script&lang=js&"
import style0 from "./PastResult.vue?vue&type=style&index=0&id=77a131b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a131b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VDataTable,VIcon,VOverlay,VProgressCircular,VRow,VSheet,VSnackbar})
